import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './ResultList.styles'

const ResultList = ({ children, hasShadow, ...rest }) => (
  <Component.List hasShadow={ hasShadow } { ...rest }>
    {children}
  </Component.List>
)

ResultList.defaultProps = {
  hasShadow: false,
}

ResultList.propTypes = {
  /** list of results */
  children: PropTypes.node,
  /** last element should be blurred */
  hasShadow: PropTypes.bool,
}

export default ResultList
